<div
  class="analytics-container"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'tablet'
        : 'mobile'
      : 'desktop'
  "
>
  <div class="no-data-container" *ngIf="!hasData">
    <img src="assets/images/analytics.svg" class="analytics-icon" />
    <h3>No data is available for the selected date range.</h3>
  </div>
  <div [hidden]="!hasData" id="chart" class="chart-container"></div>
</div>
